<template>
  <div>
    <el-popover placement="top-start" width="200" trigger="hover">
      <div class="account__div" slot="reference">
        <span style="padding: 0 20px">{{ warehousesName }}</span>
        <i class="el-icon-s-custom"></i>
        <span style="padding: 0 20px">{{ userName }}</span>
      </div>
      <ul>
        <li class="content__li" @click="switchWarehouse">切换仓库</li>
        <li class="content__li" @click="signOut">退出账号</li>
      </ul>
    </el-popover>
    <el-dialog title="切换账户" :visible.sync="dialogVisible" width="30%">
      <el-radio-group v-model="wareCode">
        <el-radio v-for="i in warehouses" :label="i.wareCode" :key="i.wareCode"> {{ i.wareName }}</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Home from "@/views/Home";
import { setUerWarehouse } from "@/apis/auth";

export default {
  name: "Account",
  components: { Home },
  computed: {
    warehouses: function () {
      return this.$store.getters.getWarehouses
    },
    oldWareCode: function () {
      return this.$store.getters.getWareCode
    },
    userName: function () {
      return this.$store.getters.getUserName
    },
    warehousesName: function () {
      return this.$store.getters.getWarehouses?.filter(item => item.wareCode == this.$store.getters.getWareCode)?.[0]?.wareName
    }
  },
  data() {
    return {
      dialogVisible: false,
      wareCode: ''
    }
  },
  inject: ['cleanKeepCache'],
  methods: {
    switchWarehouse: function () {
      this.dialogVisible = true
      this.wareCode = this.oldWareCode
    },
    submit: function () {
      const that = this
      setUerWarehouse({ wareCode: that.wareCode }).then(({ code }) => {
        if (code === 0) {
          that.dialogVisible = false
          that.$store.dispatch('menu/removeMenu')
          that.$store.dispatch('auth/setWareCode', that.wareCode)
          const warehouse = that.warehouses.find(v => v.wareCode === that.wareCode)
          const wareType = warehouse.wareNation ? (warehouse.wareName === '片山倉庫' ? '2' : '3') : '1'
          window.sessionStorage.setItem('wareType', wareType)
          if (wareType !== '1') {
            window.location.href = '/overseas/welcome'
            return
          }
          setTimeout(_ => {
            if (that.$route.path.includes('welcome')) {
              location.reload(true)
              this.cleanKeepCache()
            } else {
              that.$router.push('/welcome?isRefresh=1')
              this.cleanKeepCache()
            }
          }, 400)
        }
      })
    },
    signOut: function () {
      this.$store.dispatch('auth/removeAuth')
      this.$store.dispatch('menu/removeMenu')
      this.$store.dispatch('baseData/removeRegionList')
      setTimeout(_ => {
        this.$router.replace('/auth')
      }, 400)
    }
  },
  mounted() {

    if (!this.$store.getters.getWareCode) {
      this.signOut()
      return
    }
    localStorage.setItem('lang', 'zh')
    const ware = this.$store.getters.getWarehouses.find(v => v.wareCode === this.$store.getters.getWareCode)
    const wareType = window.sessionStorage.getItem('wareType')
    if (ware.wareNation === 1) {
      window.sessionStorage.setItem('wareType', ware.wareName === "片山倉庫"
        ? "2"
        : "3")
      window.location.href = "/overseas/welcome";
      return
    }
    if (ware.wareNation === 0 && !['1'].includes(wareType)) {
      window.sessionStorage.setItem('wareType', '1')
      location.reload()
    }
  },
}
</script>

<style scoped>
.account__div {
  min-width: 200px;
  height: 60px;
  color: white;
  font-size: 18px;
  line-height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.content__li {
  margin: 12px 24px;
  cursor: pointer;
}

.content__li:hover {
  color: #40a9ff;
}
</style>